var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(-304 -67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_42559",
    "data-name": "Path 42559",
    transform: "translate(304 67)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13 25.5 C 9.661129951477051 25.5 6.52209997177124 24.19976997375488 4.16117000579834 21.83883094787598 C 1.800230026245117 19.4778995513916 0.5 16.33886909484863 0.5 13 C 0.5 9.661129951477051 1.800230026245117 6.52209997177124 4.16117000579834 4.16117000579834 C 6.52209997177124 1.800230026245117 9.661129951477051 0.5 13 0.5 C 16.33886909484863 0.5 19.4778995513916 1.800230026245117 21.83883094787598 4.16117000579834 C 24.19976997375488 6.52209997177124 25.5 9.661129951477051 25.5 13 C 25.5 16.33886909484863 24.19976997375488 19.4778995513916 21.83883094787598 21.83883094787598 C 19.4778995513916 24.19976997375488 16.33886909484863 25.5 13 25.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 1 C 9.794679641723633 1 6.781219482421875 2.248220443725586 4.514720916748047 4.514720916748047 C 2.248220443725586 6.781219482421875 1 9.794679641723633 1 13 C 1 16.20532035827637 2.248220443725586 19.21878051757812 4.514720916748047 21.48527908325195 C 6.781219482421875 23.75177955627441 9.794679641723633 25 13 25 C 16.20532035827637 25 19.21878051757812 23.75177955627441 21.48527908325195 21.48527908325195 C 23.75177955627441 19.21878051757812 25 16.20532035827637 25 13 C 25 9.794679641723633 23.75177955627441 6.781219482421875 21.48527908325195 4.514720916748047 C 19.21878051757812 2.248220443725586 16.20532035827637 1 13 1 M 13 0 C 20.1796989440918 0 26 5.82029914855957 26 13 C 26 20.1796989440918 20.1796989440918 26 13 26 C 5.82029914855957 26 0 20.1796989440918 0 13 C 0 5.82029914855957 5.82029914855957 0 13 0 Z",
    stroke: "none",
    fill: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M13.361,12.314l4.633-4.629a.875.875,0,0,0-1.239-1.236l-5.249,5.245A.873.873,0,0,0,11.48,12.9l5.271,5.282a.875.875,0,1,0,1.239-1.236Z",
    transform: "translate(301.75 67.806)",
    fill: "#5a607f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back_btn.82d7c5f172f9f8ead81ba6273d2b931b.svg";
export { ForwardRef as ReactComponent };